module.exports = __webpack_public_path__ + "img/02.13978101.jpg";